import axios from 'axios';
import { API_URL, API_V2_URL } from '../core/common';
import { TableLoadElementsParams } from '../components/table/TablePage';

export function apiPartnersGet(token: string, videoId: string): Promise<any> {
  return new Promise<any[]>((resolve, reject) => {
    axios
      .get(API_URL + `/partners.get?video_id=${videoId}`, {
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + token,
        },
      })
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        reject(error);
      });
  });
}

export function apiPartnerSendVideo(token: string, partnerId: string, videoId: string) {
  return new Promise<any[]>((resolve, reject) => {
    axios
      .post(
        API_URL + '/partner.send_video',
        {
          partner_id: partnerId,
          video_id: videoId,
        },
        {
          headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + token,
          },
        }
      )
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        reject(error);
      });
  });
}

export function apiPartnersSendVideo(token: string, partnerIds: number[], videoId: string) {
  return new Promise<any[]>((resolve, reject) => {
    axios
      .post(
        API_URL + '/partners.send_video',
        {
          partner_ids: partnerIds.join(','),
          video_id: videoId,
        },
        {
          headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + token,
          },
        }
      )
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        reject(error);
      });
  });
}

export function apiPartnerDeleteVideo(token: string, partnerId: string, videoId: string) {
  return new Promise<any[]>((resolve, reject) => {
    axios
      .post(
        API_URL + '/partner.delete_video',
        {
          partner_id: partnerId,
          video_id: videoId,
        },
        {
          headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + token,
          },
        }
      )
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        reject(error);
      });
  });
}

export function apiPartnersGetReceive(token: string) {
  return new Promise<any[]>((resolve, reject) => {
    axios
      .get(API_URL + `/partners.get_receive`, {
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + token,
        },
      })
      .then(function (response) {
        resolve(response.data.partners);
      })
      .catch(function (error) {
        reject(error);
      });
  });
}

export function apiPartnersGetSend(token: string) {
  return new Promise<any[]>((resolve, reject) => {
    axios
      .get(API_URL + `/partners.get_send`, {
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + token,
        },
      })
      .then(function (response) {
        resolve(response.data.partners);
      })
      .catch(function (error) {
        reject(error);
      });
  });
}

export const apiPartnersGetInfo = ({ cancelToken }: TableLoadElementsParams) => {
  return new Promise((resolve, reject) => {
    axios
      .get(API_V2_URL + `/monitoring`, {
        cancelToken,
        headers: {
          Accept: 'application/json',
        },
      })
      .then(function (response) {
        resolve({
          partners: response.data,
          count: response.data.length,
        });
      })
      .catch(function (error) {
        if (!axios.isCancel(error)) {
          reject(error);
        }
      });
  });
};
